module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: [
      'logo' ]
  }, [_c('span', {
    staticClass: "logo__inner"
  }, [_c(_vm.small ? _vm.ImageBrandLogoSmall : _vm.ImageBrandLogo, {
    tag: "component",
    staticClass: "logo__image"
  }), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v(_vm._s(_vm.label))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478305f2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Logo.vue
// module id = 117
// module chunks = 3